import { render } from "./App.vue?vue&type=template&id=7f04e7c6&ts=true"
import script from "./App.vue?vue&type=script&lang=ts"
export * from "./App.vue?vue&type=script&lang=ts"

import "./App.vue?vue&type=style&index=0&id=7f04e7c6&lang=scss"

import exportComponent from "/home/brix/jenkins/workspace/Projects/Afashub/Build/staging/afashub.staging.traffix.io_-_gz2nvet4_-_Vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__